module.exports = __webpack_public_path__ + "static/splash-aa9316233141c9a39aa9abcbba6d0969.png";